import { Directive, HostListener, Input, HostBinding } from '@angular/core';
import { from } from 'rxjs/internal/observable/from';
import { take } from 'rxjs/internal/operators/take';
import { NgxSpinnerService } from 'ngx-spinner';

@Directive({
    selector: 'button[appClickWait]',
    standalone: false,
})
export class ClickWaitDirective {
    constructor(private spinner: NgxSpinnerService) {}

    @HostBinding('disabled')
    public waiting: boolean = false;

    @Input()
    appClickWait: () => Promise<any>;

    @HostListener('click')
    clickEvent(): void {
        this.waiting = true;
        this.spinner.show();
        from(this.appClickWait())
            .pipe(take(1))
            .subscribe({
                complete: (): void => {
                    this.waiting = false;
                    this.spinner.hide();
                },
                error: (e: any): void => {
                    this.waiting = false;
                    this.spinner.hide();
                    throw e;
                },
            });
    }
}
